<div
  id='overlay-container'
  *ngIf="overlayVisivel"
  class="ui-widget-overlay ui-sidebar-mask overlay-container overlay-container-inativo"
  style="z-index: 9001000;">
</div>


<mat-drawer-container
  id="mat-drawer-container"
  class="example-container inativo"
  autosize
  *ngIf="sidebarVisivel">

  <div class="bottom-panel-host">
    <ng-template
      class="bottom-panel-host"
      bottomPanelHost></ng-template>
  </div>

</mat-drawer-container>
